import { GradPlansTransferCtrl } from './grad-plans-transfer.controller';

export const GradPlansStepTransferComponent = {
  controller: GradPlansTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./grad-plans-transfer.html'),
};
